import { Component,OnInit } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { formControl } from '@app/helpers/form-control.helpers';
import { BaseModalDirective } from '../base-modal';
import Vs from '@app/services/validators/validators.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'nh-appeal-fact-modal',
    templateUrl: './appeal-fact-modal.component.html',
    styleUrls: ['./appeal-fact-modal.component.scss'],
    standalone: false
})
export class AppealFactModalComponent extends BaseModalDirective implements OnInit {
  commentsControl: FormControl;
  translatedLang;
  defaultLanguage;
  constructor(protected modalRef: BsModalRef,protected builder: FormBuilder,public translateService: TranslateService,private router: Router) {
    super(modalRef, builder);
  }

 
  ngOnInit() {
    this.commentsControl = formControl(this.body, Vs.comments);
    this.defaultLanguage = this.translateService.getDefaultLang();
    this.translatedLang = this.defaultLanguage;
    this.translateService.onDefaultLangChange.subscribe((res) => {     
      this.defaultLanguage = res.lang
      this.translatedLang = this.defaultLanguage;          
    });
          
  }

  onStart(): void {
    this.hide('');    
  }

  onCancel(): void{   
    this.hide('');
  }
  
  uploadProof() {  
    this.onCancel();
    this.router.navigate(['user-profile/my-documents', 'documents-we-need'])
  }
  appealFactForm() {  
    this.onCancel();    
    this.router.navigateByUrl("/user-profile/appeal-fact-submission");
  }
}